import { useGetFeaturesFlags } from "@/hooks/useGetFeaturesFlags/useGetFeaturesFlags";

export function useHasSentimentAnalysis(): boolean {
  const featureFlags = useGetFeaturesFlags();

  if (featureFlags?.conversationCenterDisableSentiments) {
    return false;
  }

  return true;
}
